import promoGradientBorder from '../../../utils/styles/promoGradientBorder';

export default (theme) => {
    return {
        root: {
            outline: 'none',
        },
        textareaComponents: {
            position: 'relative',
            width: 320,
            boxSizing: 'border-box',
            lineHeight: 0,
            borderRadius: 4,
            border: '1px solid transparent',
            backgroundColor: theme.colors.actionMinor[50],
            transition: 'all 0.15s ease',
        },
        textarea: {
            ...theme.typography.body,
            ...theme.utils.scrollbar,
            background: theme.colors.transparent,
            color: theme.colors.textLight.primary,
            minHeight: 38,
            width: '100% !important',
            maxWidth: '100%',
            boxSizing: 'border-box',
            outline: 'none',
            border: 'none',
            padding: '8px 48px 8px 12px',
            margin: 0,
            caretColor: theme.colors.actionMinor[500],
            '&::placeholder': {
                color: theme.colors.textLight.disabled,
            },
        },
        notResizable: {
            resize: 'none',
        },
        error: {
            '& $textareaComponents': {
                backgroundColor: theme.colors.primary.white,
                border: `1px solid ${theme.colors.semantic.negative500} !important`,
            },
        },
        isReadOnly: {
            '& $textareaComponents': {
                '&::placeholder': {
                    color: theme.colors.grey[200],
                },
            },
            '& $textarea': {
                cursor: 'text',
                color: theme.colors.grey[400],
            },
        },
        isReadAndDuplicable: {
            '& $postComponentClose': {
                display: 'inline-flex',
            },
        },
        isClickable: {
            cursor: 'pointer',
        },
        clear: {},
        clearSeparator: {
            width: 2,
            height: 8,
            backgroundColor: theme.colors.grey[100],
            margin: '0 2px',
        },
        copy: {},
        focused: {
            '& $textareaComponents': {
                backgroundColor: theme.colors.primary.white,
                border: `1px solid ${theme.colors.actionMinor[500]}`,
            },
        },
        isEnriched: {
            '& $textareaComponents': {
                ...promoGradientBorder(theme),
            },
        },
        isFullWidth: {
            width: '100%',
            '& $textareaComponents': {
                width: '100%',
                flex: 1,
            },
        },
        postComponent: {
            position: 'absolute',
            top: 8,
            right: 12,
            display: 'flex',
            alignItems: 'center',
            '& > span, > div': {
                marginLeft: 4,
                '&:first-child': {
                    marginLeft: 0,
                },
            },
        },
        postComponentClose: {
            display: 'flex',
            alignItems: 'center',
        },
        postComponentReadOnly: {},
        postComponentCopy: {},
        horizontal: {
            '& [class*="Label"]': {
                alignSelf: 'flex-start',
            },
        },
    };
};
